import React from 'react';
import { Body } from 'Organisms';

export const getBody = ({
  bodyInjected = [],
  bottomComponents,
  disableAdInjections = false,
  layoutType,
  template = 'article',
  topComponents,
  usedCarDeals,
  isMobile,
  hideSidebar = false,
}) => (
  <Body
    bodyInjected={bodyInjected}
    bottomComponents={bottomComponents}
    disableAdInjections={disableAdInjections}
    layoutType={layoutType}
    template={template}
    topComponents={topComponents}
    usedCarDeals={usedCarDeals}
    isMobile={isMobile}
    hideSidebar={hideSidebar}
  />
);
